import React from 'react';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { doc, getDoc, getFirestore } from 'firebase/firestore';

const fetchQuestions = async (event) => {
    const questionPaths = event.questions;
    const questions = [];

    const firestore = getFirestore();

    for (const path of questionPaths) {
        const segments = path.question._key.path.segments;
        const docRef = doc(firestore, ...segments.slice(-2));
        
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            console.log(docSnap)
            questions.push({
                ...docSnap.data(),
                id: docSnap.id,
            });
        }
    }

    return questions;
};

const downloadMediaAsZip = async (mediaList, event) => {
    const zip = new JSZip();
    const mediaFolder = zip.folder("media");
  
    for (let i = 0; i < mediaList.length; i++) {
      const item = mediaList[i];
      const response = await fetch(item.url);
      const blob = await response.blob();
      mediaFolder.file(`${item.question}_${item.teamName}_${i}.${item.extension}`, blob);
    }

    const truncatedEventName = (event.name || '').slice(0, 10);
    const safeEventName = truncatedEventName.replace(/[^a-zA-Z0-9]/g, '_');
  
    zip.generateAsync({ type: "blob" }).then(content => {
      saveAs(content, safeEventName + "_media.zip");
    });
};

const handleDownload = async (event, users) => {
    const allQuestions = await fetchQuestions(event);
    const mediaQuestions = allQuestions
      ? allQuestions.filter(q => ['camera', 'video', 'audio'].includes(q.type))
      : [];

    const mediaList = [];

    for (const user of users) {
        if (Array.isArray(user.answers)) {
            for (const question of mediaQuestions) {
                const foundAnswer = user.answers.find(a => a.questionId === question.id);
                if (foundAnswer && foundAnswer.answer) {
                    const truncatedTeamName = (user.teamName || '').slice(0, 10);
                    const truncatedQuestion = (question.question || '').slice(0, 10);

                    // Replace forbidden characters.
                    const safeTeamName = truncatedTeamName.replace(/[^a-zA-Z0-9]/g, '_');
                    const safeQuestion = truncatedQuestion.replace(/[^a-zA-Z0-9]/g, '_');
                    const extension = question.type === 'video' ? 'mp4' : question.type === 'audio' ? 'mp3' : 'jpg';

                    mediaList.push({
                        url: foundAnswer.answer,
                        teamName: safeTeamName,
                        question: safeQuestion,
                        extension,
                    });
                }
            }
        }
    }

    downloadMediaAsZip(mediaList, event);
};

const DownloadAllButton = ({event, users}) => {
    return (
        <div>
            <button style={{cursor: 'pointer'}} onClick={() => handleDownload(event, users)}>
                Last ned all media
            </button>
        </div>
    );
};

export default DownloadAllButton;
